<template>
  <div>
    <label :for="handle">{{ label }}</label>
    <v-select @input="change" label="bezeichnung"
              :options="options"
              :disabled="disabled"
              :value="selectedValue"
              :key="'fcw-weeks-'+changeCounter"
              :placeholder="placeholder"
              :class="inputClass">
      <span slot="no-options">Filteroptionen werden geladen...</span>
      <div slot="open-indicator" class="vs__open-indicator"></div>
    </v-select>
  </div>
</template>
<style></style>
<script>
export default {
  name: "filter-criteria-weeks",
  props: {
    label: String,
    handle: String,
    placeholder: String,
    numWeeks: { type: Number, default: 12},
    inputClass: String,
    value: [Object, Boolean, Array, Number]
  },
  computed: {
    options: function () {
      var opt = [];
      opt[0] = {code: 0,bezeichnung:'Beliebig'}
      for (let i = 1; i <= this.numWeeks; i++) {
        if(i == 1)opt[i] = {code: i,bezeichnung:'Nächste Woche'};
        else opt[i] = {code: i,bezeichnung:'Nächste ' + i + ' Wochen'};
      }
      return opt;
    }
  },
  data: function () {
    return {
      selectedValue: false,
      changeCounter: 0,
    }
  },
  watch: {

  },
  methods: {
    change: function(event){
      var datumbis = moment();
      var datumvon = moment();
      datumbis.add((event.code*7),'days');
      this.changeCounter++;
      var valueObj = { code:event.code, bezeichnung:event.bezeichnung,
        datumvon:datumvon.format('DD.MM.YYYY'), datumbis:datumbis.format('DD.MM.YYYY') };
      this.selectedValue = valueObj;
      this.$emit('input', valueObj);
    },
    setSelected: function(){
      var val = this.value[0];
      if(val){
        var optObj = this.options.find(function(o){
          return o.code == val;
        });
        this.change(optObj);
      }
    },
  },
  mounted() {
    this.setSelected();
  },
  destroyed: function() {

  }
}
</script>
